module.exports = __webpack_public_path__ + "media/two_blue.e0ee08f4.mp3";